// frameLoader
import { frameLoader } from '../embeds/frames';
import { h, render } from 'preact';

// JS files
import '../kickstart';
import '../scrolly_1';
// import '../scrolly_2';
import Locator from '../locator';
// import '../scrolly_3';
import '../scrolly_3_mesh';
// import '../scrolly_3_placeholders';
// import '../hd21_fish';
import '../hd21_results';

frameLoader();
render(<Locator />, document.getElementById('lookup'));